<template>
    <div class="radio-container">
        <div>
            <input class="form-check-input" 
                type="radio" 
                :name="name"
                :checked="checked"
                :value="value"
                @change="check($event)"
            >
            <label class="form-check-label" v-if="label">{{ label }}</label>
        </div>
    </div>
</template>
<script>
export default {
    name: "Radio",
    props: {
        label: {
            type: String,
            default: null
        },
        name: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        initChecked: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            checked: this.initChecked
        }
    },
    methods: {
        check($event) {
            this.$emit('update', $event);
        },
        setChecked(checked) {
            this.checked = checked;
        }
    }
}
</script>
<style>
.radio-container {
    line-height: 1;
    align-items: center;
    display: flex;
}

.radio-container > div {
    margin-right: 5px;
    margin-top: -2px;
}

.radio-container input[type="radio"] {
    cursor: pointer;
    margin-top: 0;
}</style>